// Vendor imports
const ReactRedux = require('react-redux')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Portal = require('client-v2/common/components/portal')
const withCommonRoot = require('client-v2/common/components/root')
const AppHeader = require('client-v2/common/containers/app-header/component-smart')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
const AppSidebar = require('client-v2/common/containers/app-sidebar/component-smart')
const { useHasSidebar } = require('client-v2/common/containers/app-sidebar/hooks')
const ArticleProfileModal = require('client-v2/common/containers/article-profile/components/modal-smart')
const AuthModal = require('client-v2/common/containers/auth-modal/component-smart')
const CollectionSelectModal = require('client-v2/common/containers/collection-select-modal/component-smart')
const ConfirmModal = require('client-v2/common/containers/confirm-modal/component-smart')
const ContentAddModal = require('client-v2/common/containers/content-add-modal/component-smart')
const FeedAwareAppFooter = require('client-v2/common/containers/feed/app-footer').default
const OpenInAppButton = require('client-v2/common/containers/open-in-app-button/component-smart')
const SeriesFeed = require('client-v2/common/containers/series-feed/component-smart')
const { useHasSeriesFeed } = require('client-v2/common/containers/series-feed/hooks')
const ShareModal = require('client-v2/common/containers/share-modal/component-smart')
const Toasts = require('client-v2/common/containers/toasts/component-smart')
const LightweightEngagementTutorialModal = require('client-v2/common/containers/lightweight-engagement/containers/tutorial/modal-smart')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const InterestProfileFeed = require('../containers/feed/component-smart')
const InterestProfileHeader = require('../containers/header/component-smart')
const InterestProfileNav = require('../containers/nav/component-smart')
const InterestProfileSeriesFeedHeader = require('../containers/series-feed-header/component-smart')

const bem = BemEntity('InterestProfileLayout')

const SERIES_FEED_ELIGIBLE_ROUTER_ACTIONS = [
  'interest-profile.showPosts'
]

function InterestProfileLayout() {
  let hasSidebar = useHasSidebar()
  let hasSeriesFeed = useHasSeriesFeed()
  // Only show the Series Feed on purely article recommendation pages
  const routerAction = ReactRedux.useSelector(state => state.router.action)
  if (!SERIES_FEED_ELIGIBLE_ROUTER_ACTIONS.includes(routerAction)) {
    hasSeriesFeed = false
  }
  const hasHeader = !hasSidebar
  const hasGridFeed = !hasSeriesFeed
  return (
    tag('div', {
      className: bem.block({
        'has-header': hasHeader,
        'has-sidebar': hasSidebar,
        'has-series-feed': hasSeriesFeed,
        'has-grid-feed': hasGridFeed
      })
    },
      hasSidebar && (
        tag(AppSidebar, {
          className: bem.element('sidebar')
        })
      ),
      hasHeader && (
        tag(AppHeader, {
          className: bem.element('header')
        })
      ),
      hasSeriesFeed && (
        tag(SeriesFeed, {
          className: bem.element('body'),
          headerElement: tag(InterestProfileSeriesFeedHeader)
        })
      ),
      hasGridFeed && tag([
        tag('div', {
          className: bem.element('body'),
          role: 'main'
        },
          tag(InterestProfileHeader),
          tag(InterestProfileNav),
          tag(InterestProfileFeed)
        ),
        tag(FeedAwareAppFooter)
      ]),
      hasHeader && (
        tag(AppNav, {
          className: 'AppNav--mobile'
        })
      ),
      Portal.toModalRoot(
        tag(ArticleProfileModal),
        tag(CollectionSelectModal),
        tag(ContentAddModal),
        tag(OpenInAppButton),
        tag(AuthModal),
        tag(ShareModal),
        tag(ConfirmModal),
        tag(Toasts),
        tag(LightweightEngagementTutorialModal)
      )
    )
  )
}

const wrappedComponent = withCommonRoot(InterestProfileLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  InterestProfileLayout
})
